import { render } from "./Copy.vue?vue&type=template&id=0e550050&scoped=true"
import script from "./Copy.vue?vue&type=script&lang=js"
export * from "./Copy.vue?vue&type=script&lang=js"

import "./Copy.vue?vue&type=style&index=0&id=0e550050&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0e550050"

export default script